import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "V2.0/common/button";

import EvalRunConfigPersonaFormDialog from "./EvalRunConfigPersonaFormDialog";
import EvalRunConfigPersonaTable from "./EvalRunConfigPersonaTable";

export default EvalRunConfigPersona;

function EvalRunConfigPersona(props) {
  const { personas, onPersonasChange } = props;

  const [evalRunConfigPersonaDialog, setEvalRunConfigPersonaDialog] = useState({
    mode: undefined,
    persona: undefined,
    personaIdx: -1,
  });

  const isModeAddPersona = evalRunConfigPersonaDialog.mode === "add";

  const handleAddPersona = (persona) => {
    const updatedPersonas = [...personas, persona];
    onPersonasChange(updatedPersonas);
  };

  const handleRemovePersona = (personaIdx) => {
    const updatedPersonas = personas.toSpliced(personaIdx, 1);
    onPersonasChange(updatedPersonas);
  };

  const handleUpdatePersona = (persona, personaIdx) => {
    const updatedPersonas = personas.toSpliced(personaIdx, 1, persona);
    onPersonasChange(updatedPersonas);
  };

  const personaDialogAddModeProps = {
    title: "Add Persona",
    confirmCtaLabel: "Add",
    onConfirm: handleAddPersona,
  };

  const personaDialogEditModeProps = {
    title: "Edit Persona",
    confirmCtaLabel: "Save",
    onConfirm: (persona) =>
      handleUpdatePersona(persona, evalRunConfigPersonaDialog.personaIdx),
  };

  return (
    <>
      <div className="flex flex-col gap-y-2">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <p className="text-sm font-medium">Persona *</p>
            <p className="text-sm text-gray-500">
              e.g., Customer, Prospect, Student
            </p>
          </div>
        </div>
        <div>
          <EvalRunConfigPersonaTable
            personas={personas}
            onEditPersona={(persona, personaIdx) => {
              setEvalRunConfigPersonaDialog({
                mode: "edit",
                persona,
                personaIdx,
              });
            }}
            onDeletePersona={handleRemovePersona}
          />
        </div>
        <div>
          <Button
            plain
            onClick={() =>
              setEvalRunConfigPersonaDialog({
                mode: "add",
                persona: {},
                personaIdx: -1,
              })
            }
          >
            <PlusIcon /> Add
          </Button>
        </div>
      </div>
      {evalRunConfigPersonaDialog.mode && (
        <EvalRunConfigPersonaFormDialog
          {...(isModeAddPersona
            ? personaDialogAddModeProps
            : personaDialogEditModeProps)}
          persona={evalRunConfigPersonaDialog.persona}
          onClose={() =>
            setEvalRunConfigPersonaDialog({
              mode: undefined,
              persona: undefined,
              personaIdx: -1,
            })
          }
        />
      )}
    </>
  );
}
